module.exports = __webpack_public_path__ + "img/exhibition_icon_vr.3de87f2a.png";